//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default [
    {
        name: 'invoice_number_id',
        type: 'select',
        flex: {
        	xs12: true,
        },
        props: {
            chips: true,
            deletableChips: true,
            itemText: 'invoice_number',
            itemValue: 'id',
            items: [],
            label: 'N° de facturas',
            rules: [RequiredRule],
        },
    },
    {
        name: 'new_invoice_number',
        type: 'text-field',
        flex: {
        	xs12: true,
        },
        props: {
            label: 'N° de factura',
            rules: [RequiredRule],
        },
    },
]
